import { connect } from 'react-redux';
import findResult from '@/utils/resultsHelper';
import { readStates } from '@/constants/lifecycle';
import fetch, { fetchConfig } from '@/hooks/fetch';
import { fetchDatasourceFeatures } from '../actions';

const DatasourceFeaturesFetch = ({
  category,
  code,
  fetchData,
  readStatus,
}) => {
  fetch.useFetchByCode(fetchData, category, code, readStatus, fetchConfig([category, code, readStatus]));
  return null;
};

export const mapStateToProps = ({
  datasetDatasource: { features },
}, { category, code }) => {
  const item = findResult(features, category, code) || { ...readStates };

  return ({
    readStatus: item.readStatus,
  });
};

export const mapDispatchToProps = {
  fetchData: fetchDatasourceFeatures,
};

export default connect(mapStateToProps, mapDispatchToProps)(DatasourceFeaturesFetch);
